/**
 * 会员信息
 */
import React from 'react';

import { Input, Row, Col, Icon, Tooltip, Button } from 'antd';

import PageLayout from '../../ui/PageLayout';
//基本信息编辑
import AgentEdit from './AgentEdit';
//代办公司下属用户维护
import MemberTeam from '../member/MemberTeam';
//充值
import MemberRecharge from '../member/MemberRecharge';
//扣款
import MemberDeduction from '../member/MemberDeduction';
//退款
import MemberRefund from '../member/MemberRefund';
//详情
import MemberDetail from '../member/MemberDetail';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import OrgSelect from '../../ui/OrgSelect';
import { global_data } from '../../ui/auth'


class AgentIndex extends React.Component {

    columns = [{
        title: '会员编码',
        dataIndex: 'code',
        width: '10%',
    }, {
        title: '代办名称',
        dataIndex: 'name',
        width: '10%',
    }, {
        title: '证件号',
        dataIndex: 'creditNo',
        width: '8%',
    }, {
        title: '账户余额',
        dataIndex: 'account',
        width: '5%',
    }, {
        title: '充值金额',
        dataIndex: 'actualAccount',
        width: '5%',
    }, {
        title: '赠送金额',
        dataIndex: 'giftAccount',
        width: '5%',
        // }, {
        //     title: '联系人',
        //     dataIndex: 'contactMan',
        //     width: '5%',
        // }, {
        //     title: '联系人电话',
        //     dataIndex: 'contactNumber',
        //     width: '5%',
        // }, {
        //     title: '地址',
        //     dataIndex: 'address',
        //     width: '13%',
    }, {
        title: '合作代办',
        dataIndex: 'cooperativeAgent',
        width: '5%',
        format: { 0: "否", 1: "是" }
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '15%',
        render: (text, record, index) => (
            <div>
                {global_data.authCode.includes("AGENT_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AGENT_MEMBER")?
                <Tooltip title="代办人员配置">
                    <Icon type="team" className="table-operate-icon" onClick={this.updateTeam.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AGENT_COOPERATE")&&record.cooperativeAgent !== 1 ?
                    <Tooltip title="设置为合作代办">
                        <Icon type="user-add" className="table-operate-icon" onClick={this.updateCooperative.bind(this, record, 1)} />
                    </Tooltip>
                :""}
                {global_data.authCode.includes("AGENT_CANCEL_COOPERATE")&&record.cooperativeAgent === 1 ?
                <Tooltip title="取消合作">
                    <Icon type="user-delete" className="table-operate-icon" onClick={this.updateCooperative.bind(this, record, 0)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AGENT_RECHARGE")?
                <Tooltip title="充值">
                    <Icon type="money-collect" theme="filled" className="table-operate-icon" onClick={this.doRecharge.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("AGENT_DEDUCTION")?
                <Tooltip title="扣款">
                    <Icon type="transaction" className="table-operate-icon" onClick={this.deduction.bind(this, record)} />
                </Tooltip>
                :""}
                {/* <Tooltip title="退款">
                    <Icon type="pay-circle" theme="filled" className="table-operate-icon" onClick={this.doRefund.bind(this, record)} />
                </Tooltip> */}
                <Tooltip title="明细">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.detail.bind(this, record)} />
                </Tooltip>
            </div>
        )
    }];

    state = {
        visible: false,
        editData: {},
        loadData: '',
        queryData: {
            agent: 1,   //至查询代办
            state: 0,   //至查询状态为启用的会员数据
        },
        teamVisible: false,
        rechargeVisible: false,
        refundVisible: false,
        deductionVisible: false,
        detailVisible: false,
        summary: {},

    };


    /// 基本信息修改

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    add = () => {
        this.setState({ editData: {}, visible: true });
    }

    update = (info, e) => {
        this.setState({ editData: info, visible: true });
    }

    ///代办人员维护
    updateTeam = (info, e) => {
        this.refs["memberTeam"].initData(info.code,
            (res) => { this.setState({ editData: info, teamVisible: true }) }
        );
    }

    onRefDetail = (ref) => {
        this.onRefDetail = ref;
    }

    //充值
    doRecharge = (info, e) => {
        this.setState({ editData: info, rechargeVisible: true });
    }

    //扣费
    deduction = (info, e) => {
        this.setState({ editData: info, deductionVisible: true });
    }

    //退款
    doRefund = (info, e) => {
        this.setState({ editData: info, refundVisible: true });
    }

    /**
     * 修改代办合作状态
     */
    updateCooperative = (info, cooperative, e) => {
        http.post({
            url: '/agent/updateCooperative',
            data: { code: info.code, cooperative: cooperative },
            success: (res) => {
                this.state.loadData(this.state.queryData)
                messager.notify("操作成功！");
            }
        });
    }

    //详情
    detail = (info, e) => {
        //查询当前账户的汇总信息
        http.post({
            url: '/agent/findAccountRecordSummary',
            data: { memberCode: info.code },
            success: (res) => {
                this.setState({ summary: res, editData: info, detailVisible: true });
                this.refs["detail"].loadTableData(info.code, "account");
                this.refs["detail"].loadTableData(info.code, "bond");
            }
        });
    }

    ///查询
    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.name = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="会员名称"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400, marginRight: '10px' }}
                                />
                                <OrgSelect style={{ width: '250px' }}
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("AGENT_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/agent/findMemberPage"
                    columns={this.columns}
                    initParams={this.state.queryData}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <AgentEdit
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <MemberTeam
                    visible={this.state.teamVisible}
                    onCancel={() => { this.setState({ teamVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    ref="memberTeam"
                    content="agent"
                />
                <MemberRecharge
                    visible={this.state.rechargeVisible}
                    onCancel={() => { this.setState({ rechargeVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="agent"
                />
                <MemberRefund
                    visible={this.state.refundVisible}
                    onCancel={() => { this.setState({ refundVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="agent"
                />
                <MemberDeduction
                    visible={this.state.deductionVisible}
                    onCancel={() => { this.setState({ deductionVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                    content="agent"
                />
                <MemberDetail
                    visible={this.state.detailVisible}
                    onCancel={() => { this.setState({ detailVisible: false, editData: {} }) }}
                    editData={this.state.editData}
                    summary={this.state.summary}
                    ref="detail"
                    content="agent"
                />
            </div>
        )
    }
}

export default AgentIndex;